import { cn } from "@/lib/utils";

// Shared CTA button look — mirrors the PickCoach mockup's `.btn` family
// (pill radius, 800-weight label, lift-on-hover) using our brand palette
// instead of hand-rolled one-off classes per component.
const BASE =
  "inline-flex items-center justify-center gap-2.5 rounded-[13px] border border-transparent text-[15px] font-extrabold leading-none transition-transform hover:-translate-y-0.5 disabled:opacity-60 disabled:pointer-events-none disabled:hover:translate-y-0";

const SIZES = {
  md: "min-h-12 px-6",
  lg: "min-h-[58px] rounded-[15px] px-7",
  xl: "min-h-[62px] rounded-[15px] px-[34px] text-[17px]",
  sm: "min-h-10 rounded-[11px] px-4 text-[13.5px]",
} as const;

const VARIANTS = {
  primary: "bg-gradient-to-br from-primary to-primary-dark text-white shadow-[0_16px_34px_rgba(21,86,255,0.24)]",
  accent: "bg-gradient-to-br from-success to-success-dark text-white shadow-[0_16px_32px_rgba(0,200,83,0.22)]",
  dark: "bg-foreground text-white hover:brightness-110",
  light: "border-[#CBD5E1]/95 bg-white/74 text-foreground backdrop-blur-md hover:bg-white",
  destructive: "bg-destructive text-white hover:brightness-110",
  warning: "bg-rating text-white hover:brightness-110",
  ghost: "text-muted-foreground hover:text-foreground",
} as const;

export type ButtonVariant = keyof typeof VARIANTS;
export type ButtonSize = keyof typeof SIZES;

export function btn(variant: ButtonVariant, size: ButtonSize = "md", className?: string) {
  return cn(BASE, SIZES[size], VARIANTS[variant], className);
}
